module.exports = __webpack_public_path__ + "static/media/layer4M.1ec9d63a.png";